// ✔ This Context is global
// ✔ Used by Login, Profile, Dashboard, Calendar, etc.
// ✔ This makes user and accessToken available in any component without prop drilling feature.

import React, { createContext, useState, useContext } from "react";

// create context
const UserContext = createContext();

// provider wrapper
export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [accessToken, setAccessToken] = useState(null);

    return (
        <UserContext.Provider value={{ user, setUser, accessToken, setAccessToken }}>
            {children}
        </UserContext.Provider>
    );
}

// custom hook for easy usage
export function useUser() {
    return useContext(UserContext);
}

